// ABOUTME: Trend Δ% pills shown next to each pivot relation — vs last year, vs previous period, and across the period.
// ABOUTME: previous/lastYear come from the backend row.comparison; "across" is derived from the row values (first half vs second half, ignoring the in-progress last bucket).
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import { pivotTrendVariants } from "../../reportUtils";

const TrendPill = ({ delta, current, label }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const hasDelta = delta !== null && delta !== undefined && isFinite(delta);
    // No baseline (base was 0): "new" if it grew from nothing, otherwise nothing to compare.
    const isNew = !hasDelta && (current || 0) > 0;
    if (!hasDelta && !isNew) return null;

    const isFlat = hasDelta && Math.abs(delta) < 1;
    const isUp = !hasDelta || delta > 0;
    const arrow = isFlat ? '→' : (isUp ? '↑' : '↓');

    const palette = isFlat
        ? { bg: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100], text: colors.grey[400] }
        : isUp
            ? { bg: colors.green[100], text: colors.green[400] }
            : { bg: colors.red[100], text: colors.red[400] };

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                background: palette.bg,
                borderRadius: 3,
                px: 1,
                height: 20,
                flexShrink: 0,
                userSelect: 'none',
            }}
        >
            <Box component="span" sx={{ color: palette.text, fontSize: 10, fontWeight: 700 }}>
                {hasDelta ? `${arrow} ${Math.abs(delta).toFixed(Math.abs(delta) < 10 ? 1 : 0)}%` : `${arrow} ${t('new')}`}
            </Box>
        </Box>
    );
};

// Within-period trend: first half vs second half of the period, ignoring the in-progress last bucket.
const acrossTrend = (values) => {
    if (!values || values.length < 3) return { delta: null };
    const vals = values.slice(0, -1); // drop the in-progress (today) bucket so it doesn't skew the trend
    const half = Math.floor(vals.length / 2);
    if (half < 1) return { delta: null };
    const avg = (arr) => arr.reduce((sum, v) => sum + (Number(v) || 0), 0) / (arr.length || 1);
    const first = avg(vals.slice(0, half));
    const second = avg(vals.slice(half));
    return { delta: first > 0 ? ((second - first) / first) * 100 : null, current: second };
};

export const RhTrendPills = ({ row, trends = [] }) => {
    const { t } = useTranslation();
    const comparison = row?.comparison;

    return (
        <>
            {trends.includes(pivotTrendVariants.LAST_YEAR) && (
                <Box
                    sx={{
                        width:130,
                        flexShrink:0,
                        display:'flex',
                        alignItems:"center",
                        justifyContent:"flex-end",
                    }}
                >
                    <TrendPill delta={comparison?.lastYear?.delta} current={row?.total} label={t('vs_last_year')} />
                </Box>
            )}
            {trends.includes(pivotTrendVariants.PREVIOUS) && (
                <Box
                    sx={{
                        width:130,
                        flexShrink:0,
                        display:'flex',
                        alignItems:"center",
                        justifyContent:"flex-end",
                    }}
                >
                    <TrendPill delta={comparison?.previous?.delta} current={row?.total} label={t('vs_prev_period')} />
                </Box>
            )}
        </>
    );
};
